import { useAsync } from '@nxsys/hooks/useAsync';
import {
  calculateUmbrellaRateApi,
  getRateConfigsApi,
} from '@nxsys/services/api/umbrella-rate-calculator';
import {
  UmbrellaRateCalculatorResponse,
  UmbrellaRateCalculatorParams,
  RateConfigsResponse,
} from '@nxsys/types/models/kid/umbrella-rate-calculator';

export const useCalculateUmbrellaRate = () => {
  const { value, loading, error, run } = useAsync<
    UmbrellaRateCalculatorResponse,
    UmbrellaRateCalculatorParams
  >(calculateUmbrellaRateApi);

  return { value, loading, error, run };
};

export const useGetRateConfigs = () => {
  const { value, loading, error, run } = useAsync<
    RateConfigsResponse,
    number
  >(getRateConfigsApi);

  return { value, loading, error, run };
};
